import store from '../store';
export const connectWS = () => {
  var { uid } = store.getState().infos;
  return (Dispatch) => {
    Dispatch({type: 'SOCKETS_CONNECT_SOCKET', uid: uid});
  };
};
export const setActive = (state) => {
  return (Dispatch) => {
    Dispatch({type: 'SOCKETS_SETUP_ACTIVE', state: state});
  };
};
